import { getStaticAsset } from "core/model/config";
import { Banner, Image } from "ds/ui";
import { ShieldAlertIcon } from "lucide-react";
import { useTranslations } from "translations";

/**
 * Shared "this source document is gone" state, used for any source type
 * (HIS/Recare files, KIS data, voice transcripts, ...) whose underlying
 * document is no longer available.
 */
export function DeletedSourceBanner() {
  const translations = useTranslations();

  return (
    <div className="flex h-full w-full flex-1 flex-col">
      <Banner
        color="warning"
        icon={ShieldAlertIcon}
        message={
          translations.extractDocs.splitView.sourceInformation
            .sourceDeletedTooltip
        }
      />
      <div className="flex w-full flex-1 flex-col items-center justify-center bg-gray-50">
        <Image
          aria-hidden="true"
          className="h-[160px] w-auto overflow-visible"
          src={getStaticAsset("docs-deleted-source.svg")}
        />
        <p className="w-[50%] text-center text-heading-md text-gray-600">
          {
            translations.extractDocs.splitView.sourceInformation
              .sourceDeletedDescription
          }
        </p>
      </div>
    </div>
  );
}
